import React from "react";

import { Box } from "@mui/material";

import { LongTextBlock, LongTextResponse } from "../types";

interface Props {
  question: LongTextBlock;
  response: LongTextResponse;
}

const LongText: React.FC<Props> = ({ question, response }) => {
  return (
    <Box>
      <Box fontSize={14} fontWeight="600" color="#7D8797">
        {question.data.title}
      </Box>
      <Box p="16px" border="1px solid #DEE6F0" mt="12px" whiteSpace="pre-wrap">
        {response.data}
      </Box>
    </Box>
  );
};

export default LongText;
